<template>
  <div id="app">
   <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  metaInfo () {
    return {
      title: 'Intro',
      titleTemplate: '%s - Quickin'
    }
  }
}
</script>

<style lang="scss">
@import "./assets/scss/tooltip.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue